export default __webpack_public_path__ + "c588fc14134386354ce428f8cbc30075.svg";